// Chakra imports
import {Box, Portal} from '@chakra-ui/react';
import Footer from '../components/footer/FooterAdmin.js';
// Layout components
import Navbar from '../components/navbar/NavbarAdmin.js';
import Sidebar from '../components/sidebar/Sidebar.js';
import {SidebarContext} from '../contexts/SidebarContext';
import React, {useState} from 'react';
import {Outlet} from 'react-router-dom';

// Custom Chakra theme
export default function MainDashboard(props) {
    const {...rest} = props;
    // states and functions
    const [toggleSidebar, setToggleSidebar] = useState(false);
    // functions for changing the states from components
    document.documentElement.dir = 'ltr';
    return (
        <Box>
            <Box>
                <SidebarContext.Provider
                    value={{
                        toggleSidebar,
                        setToggleSidebar,
                    }}
                >
                    <Sidebar display="none" {...rest} />
                    <Box
                        float="right"
                        minHeight="100vh"
                        height="100%"
                        overflow="auto"
                        position="relative"
                        maxHeight="100%"
                        w={{base: '100%', xl: 'calc( 100% - 290px )'}}
                        maxWidth={{base: '100%', xl: 'calc( 100% - 290px )'}}
                        transition="all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)"
                        transitionDuration=".2s, .2s, .35s"
                        transitionProperty="top, bottom, width"
                        transitionTimingFunction="linear, linear, ease"
                    >
                        <Portal>
                            <Box>
                                <Navbar/>
                            </Box>
                        </Portal>


                        <Box
                            mx="auto"
                            p={{base: '20px', md: '30px'}}
                            pe="20px"
                            minH="100vh"
                            pt="50px"
                        >
                            <Outlet/>
                        </Box>
                        <Box>
                            <Footer/>
                        </Box>
                    </Box>
                </SidebarContext.Provider>
            </Box>
        </Box>
    );
}
